import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import gql from "graphql-tag";

import { CustomerInfo, CustomerInfoVariables } from "./types/CustomerInfo";

export const customerInfoListQuery = gql`
  ${pageInfoFragment}
  query CustomerInfo(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: CustomerInfoFilterInput!
  ) {
    customerInfo(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          user_id
          email
          date_joined
          first_name
          last_name
          gender
          date_of_birth
          contact_no
          street_address_1
          email
        }
      }
    }
  }
`;

export const useCustomerInfoListQuery = makeBossQuery<
  CustomerInfo,
  CustomerInfoVariables
>(customerInfoListQuery);
